module.exports = __webpack_public_path__ + "img/installed-programs.af630cb3.svg";